import * as React from 'react'

type cell = string
type row = cell[]
export type bucket = row[]

const Bucket = ({ rows }: { rows: bucket }) => <table className="bucket"><tbody>{Rows(rows)}</tbody></table>

const Rows = (rows: bucket) => rows.map((row, index) => <Row cells={row} key={index} />)
const Row = ({ cells }: { cells: row }) => <tr>{Cells(cells)}</tr>

const Cells = (cells: row) => cells.map((cell, index) => <Cell shape={cell} key={index} />)
const Cell = ({ shape }: { shape: cell }) => <td className={'tetromino-' + shape}></td>

export default Bucket
